import { mergeWith } from 'lodash';

export default {
  setConditions: (state, { page, searchText, startDate, endDate, orderState, orderType, reservedDate, storeNo }) => {
    state.params.page = page;
    state.params.searchText = searchText;
    state.params.startDate = startDate;
    state.params.endDate = endDate;
    state.params.orderState = orderState;
    state.params.orderType = orderType;
    state.params.reservedDate = reservedDate;
    state.params.storeNo = storeNo;
  },
  setPageInfo: (state, pageInfo) => {
    state.pageInfo = pageInfo;
  },
  setList: (state, list) => {
    state.list = list;
  },
  setDetail: (state, detail) => {
    state.detail = detail;
  },
  flushDetail: (state) => {
    state.detail = {
      orderNo: 0,
      orderManageNo: '-',
      storeNo: 0,
      userNo: 0,
      name: '-',
      phone: '-',
      address: '-',
      addressDetail: '',
      longitude: '',
      latitude: '',
      orderState: '',
      bank: '',
      accountNumber: '',
      depositHolder: '',
      orderType: '-',
      orderDate: '-',
      reservedDate: null,
      inquiry: '-',
      paymentMethod: '',

      orderIncomeTime: '',
      orderCheckTime: '',
      cookingTime: '',
      deliveryTime: '',
      completedTime: '',
      cancelledTime: '',
      cookingDuration: '',
      deliveryDuration: '',

      cancelReason: '',
      isCustomerCancellation: '',
      memo: '',
      totalProductsPrice: '',
      deliveryFee: '',
      discountAmount: '',
      couponDiscountAmount: '',
      pointUsageAmount: '',
      cancelledAmount: '',
      balance: '',
      isShow: '',
      orderDetails: []
    };
  }
};
